function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Smart_charging_poles"
}, /*#__PURE__*/React.createElement("title", null, "VF_Rityta 1_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M191.3 255.1v-28.2h.1l14.2-.2c23.4-.2 42.3-19.2 42.3-42.6V72.6l34.7-17.3L270 29.8 219.6 55v129.2c0 7.8-6.3 14.1-14.1 14.1l-14.2.2V28.3C191.3 12.7 178.7 0 163 0h-42.5c-15.7 0-28.3 12.7-28.3 28.3v226.8H63.9v28.3h219.7v-28.3h-92.3zM163 28.3v226.8h-42.5V28.3H163zM77.9 42.5H44.5L56.7 0 0 70.9h33.4l-12.1 42.5z"
}))));